const localStorageKeys = {
	USER_DATA: "app.userData",
};
export default localStorageKeys;
